// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 50vh;
  /* Ensure the wrapper takes up the full viewport height */
}

main {
  flex: 1;
  /* Push the footer to the bottom by taking up remaining space */
}

footer {
  background: #333;
  color: white;
  text-align: center;
  padding: 10px;
}

.content-blur {
  filter: blur(15px) brightness(0.3);
  /* extremely blurred & dark */
  pointer-events: none;
  /* stop interaction */
}

.trial-banner-block {
  display: block;
  position: absolute;
  top: 50px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/webfacing/webfacing.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,OAAO;EACP,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 50vh;\n  /* Ensure the wrapper takes up the full viewport height */\n}\n\nmain {\n  flex: 1;\n  /* Push the footer to the bottom by taking up remaining space */\n}\n\nfooter {\n  background: #333;\n  color: white;\n  text-align: center;\n  padding: 10px;\n}\n\n.content-blur {\n  filter: blur(15px) brightness(0.3);\n  /* extremely blurred & dark */\n  pointer-events: none;\n  /* stop interaction */\n}\n\n.trial-banner-block {\n  display: block;\n  position: absolute;\n  top: 50px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
